import React from 'react';
import Model from '../../components/Model';

export default function MacroButton() {
  return (
    <Model
      title={'Accessibee Macro Button'}
      src={'/video/mobile/assigning-accessibee-button.mp4'}
      para1={
        "Accessibee includes a convenient macro button with the app's logo that enables users to assign an accessibility setting for easy access throughout the app. This feature allows users to activate their preferred accessibility setting regardless of their current location within the app. As an example, the demo showcases how users can use this feature to access the zoom functionality."
      }
    />
  );
}
